module.exports = __webpack_public_path__ + "static/media/background_login.932d4672.webp";